// <script>
import { first, length, scan } from "@pdfking/rfunc"
import { GenericHash, RecordMerge, UnixTime } from "@pdfking/tfunc"
import { settings_get } from "@pdfking/workflow/state/settings"
import user from "../../state/user"
import { make_promise } from "../load"

//   (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
//   new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
//   j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
//   '//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
//   })(window,document,'script','%(data_layer_name)s','%(tracking_id)s');
// </script>

let resolve = null

const promise = new Promise(r => (resolve = r))

// @ts-expect-error TS2339
window.dataLayer = []

function gtag() {
  if (length(arguments) > 1) {
    // @ts-expect-error TS2339
    window.dataLayer.push(arguments)
  } else {
    // @ts-expect-error TS2339
    window.dataLayer.push(first(arguments))
  }
  // @ts-expect-error TS2339
  window.dataLayer.push(function () {
    // @ts-expect-error TS2683
    this.reset()
  })
}

const make_ready =
  (...funcs) =>
  (...args) => {
    promise.then(() => scan(f => f(...args), funcs))
  }

const add_globals = (...args) =>
  RecordMerge(
    {
      user_id: user().id ? GenericHash([user().id]) : null,
      user_staff: !!user().is_staff,
    },
    settings_get("settings"),
    ...args
  )

const gtag_init = async id => {
  await make_promise(`https://www.googletagmanager.com/gtm.js?id=${id}`).then(
    resolve
  )

  gtag(
    // @ts-expect-error TS2554
    "config",
    id,
    add_globals({
      send_page_view: false,
    })
  )
  // gtag("consent", "default", consent.default)
  // @ts-expect-error TS2554
  gtag(add_globals({ event: "gtm.js", "gtm.start": UnixTime() * 1000 }))
}

export default {
  // @ts-expect-error TS2554
  gtag: make_ready((...args) => gtag(add_globals(...args))),
  // @ts-expect-error TS2556
  load: (...args) => gtag_init(...args),
}
